import { render } from "./TableIfControlSection.vue?vue&type=template&id=1f05b7d1"
import script from "./TableIfControlSection.vue?vue&type=script&lang=js"
export * from "./TableIfControlSection.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__